module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-latin-ext243.808ab3c.woff2";